
import { Session } from "@supabase/supabase-js";
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useNavigate } from "react-router-dom";

export function useSession() {
  const [session, setSession] = useState<Session | null>(null);
  const [isInitialized, setIsInitialized] = useState(false);
  const navigate = useNavigate();

  const clearSessionAndRedirect = async () => {
    // Clear the local session state first
    setSession(null);
    
    // Clear any session data from localStorage
    localStorage.removeItem('app-session');
    localStorage.removeItem('supabase.auth.token');
    
    // Navigate to auth page
    navigate("/auth");
  };

  useEffect(() => {
    const initializeSession = async () => {
      try {
        const { data: { session: currentSession }, error: sessionError } = await supabase.auth.getSession();
        
        if (sessionError) {
          console.error('Session error:', sessionError);
          await clearSessionAndRedirect();
          return;
        }

        setSession(currentSession);

        const {
          data: { subscription },
        } = supabase.auth.onAuthStateChange(async (_event, newSession) => {
          setSession(newSession);
        });

        setIsInitialized(true);
        return () => subscription.unsubscribe();
      } catch (error) {
        console.error('Initialization error:', error);
        await clearSessionAndRedirect();
      }
    };

    initializeSession();
  }, [navigate]);

  return {
    session,
    isInitialized,
    clearSessionAndRedirect
  };
}
